import { useTranslation } from 'react-i18next';

import { Button } from '@/components/common/Button';
import { PanelNotice, PanelWaiting } from '@/components/hub/PanelNotice';
import { useTorneiDelGioco } from '@/hooks/useTorneiDelGioco';
import { BURRACO_GAME_ID } from '@/lib/gameFeatures';
import { limuloFailure } from '@/lib/limulo/errors';
import { LimuloDegraded } from '@/routes/limulo/LimuloDegraded';
import { TorneiQuattroTab } from '@/routes/limulo/TorneiQuattroTab';

/**
 * I tornei del Burraco nella sua Hub (PR1 dell'ingresso; Z2 di tma-orcb: «`useTorneiDelGioco` com'e', nessun hook nuovo»): la lista dei SOLI tornei del catalogo
 * Limulo con `profileType: 'burraco'` (`PROFILE_TYPE_DEL_GIOCO`), con le stesse quattro tab e la stessa riga dei tornei di scacchi e backgammon. E il gemello di
 * `ChessTournamentsPanel`: il filtro e i cinque vuoti stanno nel corpo comune `useTorneiDelGioco`, qui si scrive solo cio che ognuno dice. ⛔ «Nessun torneo di
 * Burraco» e il caso 5 e si dice SOLO quando il server ha parlato per intero; senza catalogo, o con un catalogo senza burraco (l'app non e attivata
 * sull'organizzazione), e il caso 4: «non disponibile», mai un vuoto.
 *
 * Non ha una radice che scorre: la scorre `HubBurraco`, che la tiene insieme ai tavoli.
 */
export function TorneiBurraco() {
  const { t } = useTranslation('burraco');
  const { t: tl } = useTranslation('limulo');
  const { state, tournaments, canLoadMore, loadingMore, loadMore, gameId } = useTorneiDelGioco({ gioco: BURRACO_GAME_ID });

  let corpo;
  if (state.kind === 'cannot-ask') {
    corpo = <PanelNotice tone="unavailable" className="h-auto py-6" />;
  } else {
    const avviso =
      state.kind === 'waiting' ? (
        <PanelWaiting slow={state.slow} className="h-auto py-4" />
      ) : state.kind === 'no-answer' ? (
        <PanelNotice tone="error" className="h-auto py-6" />
      ) : state.kind === 'failed' ? (
        <LimuloDegraded failure={limuloFailure(state.error)} context="list" />
      ) : null;
    // `<Button>` comune (la primitiva: `tools/verify-bottoni.ts` non ammette `<button>` a mano nei file nuovi).
    const more = canLoadMore ? (
      <Button variant="secondary" fullWidth disabled={loadingMore} onClick={loadMore}>
        {loadingMore ? tl('list.loadingMore') : tl('list.loadMore')}
      </Button>
    ) : null;
    corpo = (
      <TorneiQuattroTab
        pubblicati={state.kind === 'ok' || state.kind === 'empty' ? tournaments : null}
        avviso={avviso}
        coda={more}
        vuotoDelGioco={t('hub.tornei.vuoto')}
        gameIdMiei={gameId}
      />
    );
  }

  return (
    <section data-testid="burraco-tornei" aria-labelledby="burraco-tornei-titolo" className="flex flex-col gap-2">
      <h2 id="burraco-tornei-titolo" className="text-xs font-bold uppercase tracking-wide text-fg-muted">
        {t('hub.tornei.titolo')}
      </h2>
      {corpo}
    </section>
  );
}
